// @flow

import React from 'react';
import ReactDOM from 'react-dom';
import * as components from './components';
import * as templates from './templates/spaTemplates';
import './styles/globals/globals.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.Components = components;
global.Templates = { ...templates };
global.analytics =
  typeof analytics !== 'undefined'
    ? analytics
    : {
        trackLink: () => {},
        track: () => {},
      };
